import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../../../theme';

export default StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    borderWidth: 1,
    borderColor: colorPalette.primaryLighter,
    borderRadius: 18,
    paddingVertical: 12,
    flexDirection: 'row',
    marginHorizontal: 16,
    marginBottom: 20,
    overflow: 'hidden',
  },
  context: {
    color: colorPalette.grey8_5,
    fontFamily: textStyles.regular,
    fontSize: 16,
    marginLeft: 8,
    flex: 1,
    marginRight: 16,
  },
  icon: {
    marginLeft: 16,
  },
});
